import '@/app-shared/extension/mobile-detect';
import Vue from 'vue';
// 控制台日志打印处理
import '@/app-shared/extension/vh-console';
// 重置 elementUI 的 message
import '@/app-shared/extension/message';
// 全局属性的定义
import './init-global/prototype';
// 导入根组件
import App from './App.vue';
// 组件库环境全局配置
import './init-global/hcl-config';
// 导入路由
import router from './router';
// 引入国际化组件
import i18n, { loadLocaleMessages } from '@/app-shared/i18n/index';
// domain store
import domainStore from './init-global/store';
// 全局属性及方法
import '@/app-shared/extension/global';
// 全局混入
import '@/app-shared/mixins/index';
// 全局指令
import '@/app-shared/directives/index';
// 全局过滤器
import '@/app-shared/filters/index';
// 导入规范公用样式
import '@/app-shared/assets/css/standard/common.less';
// 导入样式及皮肤
import './assets/styles/common.less';
//iframe嵌入场景通信
import '@/app-shared/utils/embedToParent.js';
// 默认主题
import skins from '@/app-shared/skins/watch';

skins.applyTheme(`theme_default_black`);

const localLang = localStorage.getItem('lang');
loadLocaleMessages(localLang == 2 ? 'en' : 'zh');

// 开启调试工具
Vue.config.productionTip = false;
if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true;
}

Vue.config.ignoredElements = ['wx-open-subscribe', 'wx-open-launch-weapp'];

//三方组件库
Vue.use(VueLazyload, {
  observer: true
});

dayjs.extend(window.dayjs_plugin_duration);

new Vue({
  router,
  i18n,
  domainStore,
  render: h => h(App)
}).$mount('#app');
